export const MODES = {
    EDITING: "editing",
    VIEWING: "viewing"
}